import Vue from "vue";
import Router from "vue-router";

import GamesCombi from "./views/GamesCombi.vue";
import SingleGameCombi from "./views/SingleGameCombi.vue";

import Games from "./views/Games.vue";
import SingleGame from "./views/SingleGame.vue";

import Categories from "./views/Categories.vue";
import SingleCategory from "./views/SingleCategory.vue";

import Format from "./views/Format.vue";
import SingleFormat from "./views/SingleFormat.vue";

import Item from "./views/Item.vue";
import SingleItem from "./views/SingleItem.vue";

import Packages from "./views/Packages.vue";
import SinglePackage from "./views/SinglePackage.vue";

import AddonProducts from "./views/AddonProducts.vue";
import SingleAddonProduct from "./views/SingleAddonProduct.vue";

import PackageEquipmentProducts from "./views/PackageEquipmentProducts.vue";
import SinglePackageEquipmentProduct from "./views/SinglePackageEquipmentProduct.vue";

import Producers from "./views/Producers.vue";
import SingleProducer from "./views/SingleProducer.vue";

import Materials from "./views/Materials.vue";
import SingleMaterial from "./views/SingleMaterial.vue";

import ExtraCharge from "./views/ExtraCharge.vue";
import SingleExtraCharge from "./views/SingleExtraCharge.vue";

import Offers from "./views/Offers.vue";
import SingleOffer from "./views/SingleOffer.vue";

import Orders from "./views/Orders.vue";
import SingleOrder from "./views/SingleOrder.vue";

import Users from "./views/Users.vue";
import SingleUser from "./views/SingleUser.vue";

import Banned from "./views/Banned.vue";
import SingleBanned from "./views/SingleBanned.vue";

import Configuration from "./views/Configuration.vue";
import SingleConfiguration from "./views/SingleConfiguration.vue";

import Printprocedures from "./views/Printprocedures.vue";
import SinglePrintprocedure from "./views/SinglePrintprocedure.vue";

import Whitelabel from "./views/Whitelabel.vue";
import SingleWhitelabel from "./views/SingleWhitelabel.vue";

import Whitelist from "./views/Whitelist.vue";
import SingleWhitelist from "./views/SingleWhitelist.vue";

import Warning from "./views/Warning.vue";

import Rules from "./views/Rules.vue";
import SingleRule from "./views/SingleRule.vue";

import Commissions from "./views/Commissions.vue";
import SingleCommission from "./views/SingleCommission.vue";


Vue.use(Router);

export default new Router({
  //mode: "history",
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "gamescombi",
      component: GamesCombi
    },
    {
      path: "/spielkombi/:id",
      name: "editgamecombi",
      component: SingleGameCombi
    },
    {
      path: "/spielkombi",
      name: "creategamecombi",
      component: SingleGameCombi
    },
    {
      path: "/spiele",
      name: "games",
      component: Games
    },
    {
      path: "/spiel/:id",
      name: "editgame",
      component: SingleGame
    },
    {
      path: "/spiel",
      name: "creategame",
      component: SingleGame
    },
    {
      path: "/spielarten",
      name: "categories",
      component: Categories
    },
    {
      path: "/spielart/:id",
      name: "editcategory",
      component: SingleCategory
    },
    {
      path: "/spielart",
      name: "createcategory",
      component: SingleCategory
    },
    {
      path: "/formate",
      name: "formate",
      component: Format
    },
    {
      path: "/format/:id",
      name: "editformat",
      component: SingleFormat
    },
    {
      path: "/format",
      name: "createformat",
      component: SingleFormat
    },
    {
      path: "/umfaenge",
      name: "umfang",
      component: Item
    },
    {
      path: "/umfang/:id",
      name: "editumfang",
      component: SingleItem
    },
    {
      path: "/umfang",
      name: "createumfang",
      component: SingleItem
    },
    {
      path: "/verpackungen",
      name: "packages",
      component: Packages
    },
    {
      path: "/verpackung/:id",
      name: "editpackage",
      component: SinglePackage
    },
    {
      path: "/verpackung",
      name: "createpackage",
      component: SinglePackage
    },
    {
      path: "/zusatzprodukte",
      name: "addonproducts",
      component: AddonProducts
    },
    {
      path: "/zusatzprodukt/:id",
      name: "editaddonproduct",
      component: SingleAddonProduct
    },
    {
      path: "/zusatzprodukt",
      name: "createaddonproduct",
      component: SingleAddonProduct
    },
    {
      path: "/package-equipments",
      name: "packageequipments",
      component: PackageEquipmentProducts
    },
    {
      path: "/package-equipment/:id",
      name: "editpackageequipment",
      component: SinglePackageEquipmentProduct
    },
    {
      path: "/package-equipment",
      name: "createpackageequipment",
      component: SinglePackageEquipmentProduct
    },
    {
      path: "/hersteller",
      name: "producer",
      component: Producers
    },
    {
      path: "/producer/:id",
      name: "editproducer",
      component: SingleProducer
    },
    {
      path: "/materialen",
      name: "materials",
      component: Materials
    },
    {
      path: "/material",
      name: "creatematerial",
      component: SingleMaterial
    },
    {
      path: "/material/:id",
      name: "editmaterial",
      component: SingleMaterial
    },
    {
      path: "/druckverfahren",
      name: "printprocedure",
      component: Printprocedures
    },
    {
      path: "/printprocedure",
      name: "createprintprocedure",
      component: SinglePrintprocedure
    },
    {
      path: "/printprocedure/:id",
      name: "editprintprocedure",
      component: SinglePrintprocedure
    },
    {
      path: "/producer",
      name: "createproducer",
      component: SingleProducer
    },
    {
      path: "/extracharges",
      name: "extracharges",
      component: ExtraCharge
    },
    {
      path: "/extracharge/:id",
      name: "editextracharge",
      component: SingleExtraCharge
    },
    {
      path: "/extracharge",
      name: "createextracharge",
      component: SingleExtraCharge
    },
    {
      path: "/offers",
      name: "offers",
      component: Offers
    },
    {
      path: "/offer/:id",
      name: "editoffer",
      component: SingleOffer
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders
    },
    {
      path: "/order/:id",
      name: "editorder",
      component: SingleOrder
    },
    {
      path: "/users",
      name: "user",
      component: Users
    },
    {
      path: "/user/:id",
      name: "edituser",
      component: SingleUser
    },
    {
      path: "/user",
      name: "createuser",
      component: SingleUser
    },
    {
      path: "/whitelabels",
      name: "whitelabel",
      component: Whitelabel
    },
    {
      path: "/whitelabel/:id",
      name: "editwhitelabel",
      component: SingleWhitelabel
    },
    {
      path: "/whitelabel",
      name: "createwhitelabel",
      component: SingleWhitelabel
    },
    {
      path: "/banned-list",
      name: "banned",
      component: Banned
    },
    {
      path: "/banned/:id",
      name: "editbanned",
      component: SingleBanned
    },
    {
      path: "/banned",
      name: "createbanned",
      component: SingleBanned
    },
    {
      path: "/whitelist-list",
      name: "whitelist",
      component: Whitelist
    },
    {
      path: "/whitelist/:id",
      name: "editwhitelist",
      component: SingleWhitelist
    },
    {
      path: "/whitelist",
      name: "createwhitelist",
      component: SingleWhitelist
    },
    {
      path: "/configurations",
      name: "configuration",
      component: Configuration
    },
    {
      path: "/configuration/:id",
      name: "editconfiguration",
      component: SingleConfiguration
    },
    {
      path: "/configuration",
      name: "createconfiguration",
      component: SingleConfiguration
    },
    {
      path: "/hinweise",
      name: "warning",
      component: Warning
    },
    {
      path: "/rules",
      name: "rules",
      component: Rules
    },
    {
      path: "/rule/:id",
      name: "editrule",
      component: SingleRule
    },
    {
      path: "/rule",
      name: "createrule",
      component: SingleRule
    },
    {
      path: "/commissions",
      name: "commissions",
      component: Commissions
    },
    {
      path: "/commission/:id",
      name: "editcommission",
      component: SingleCommission
    },
    {
      path: "/configuration",
      name: "createcommission",
      component: SingleCommission
    },


  ]
});
